<template>
  <v-row align="center" dense class="ml-0">
    <v-col cols="auto">
      <tcn-au-user-avatar :value="user" size="30" left/>
    </v-col>
    <v-col cols="auto" class="user-details">
            <span class="font-weight-bold"
            >{{ user.firstName }} {{ user.lastName }}</span
            >
      <span
          v-if="!user.firstName && !user.lastName"
          class="font-weight-bold"
      >
              ({{ user.username }})
            </span>
      <br />
      <span style="font-weight: 400">{{ user.email }}</span>
    </v-col>
  </v-row>
</template>

<script>
import TcnAuUserAvatar from "../../aurea/TecnaAureaUserAvatar/TcnAuUserAvatar.vue";
export default {
  name: "UserSuggestion",
  props: ['user'],
  components: {TcnAuUserAvatar},
}
</script>

<style scoped>

</style>
